import React from 'react';
import { Button, Carousel, Container } from 'react-bootstrap';
import { BiLinkExternal } from 'react-icons/bi';
import Particle from '../../Particle';


import doctorsPortal from "../../../Images/Project/doctorsPortal/doctorHome.JPG";
import doctorAppointment from "../../../Images/Project/doctorsPortal/appointment.JPG";
import doctorDashboard from "../../../Images/Project/doctorsPortal/dashboard.JPG";
import doctorLogin from "../../../Images/Project/doctorsPortal/doctorLogin.JPG";

const Doctors = () => {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    Doctor's Portal <strong className="purple"> Website </strong>
                </h1>
                <div className='mt-5 mb-5'>
                    <div className='container '>
                        <div className='row '>
                            <div className='col-lg-6 col-sm-12'>
                                <Carousel fade>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={doctorsPortal}
                                            alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={doctorAppointment}
                                            alt="Second slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={doctorDashboard}
                                            alt="Third slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={doctorLogin}
                                            alt="fourth slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </div>
                            <div className='col-lg-6 col-sm-12'>
                                <p className='text-white'>This is an Full-Stack Doctors Portal Website.Patients can Login via (Google,Facebook)and can Create account. patients can book Appointment by Date.Doctor can manage Appointment and see the appointment by data.User can Complete her/his Payment via Online payment system(Strip). </p>

                                <p className='text-white'>
                                    <ul>
                                        <li>Have Doctors and Patients Dashboard.</li>
                                        <li>Doctors can add,delete,manage appointment</li>
                                        <li>Admin can delete, add, manage services.</li>
                                        <li>Admin can Make Admin also</li>
                                    </ul></p>
                                <p className='text-white'> Front-end technology: React js, Bootstrap,React Router, Firebase Authentication</p>
                                <p className='text-white'> Back-end technology:Node js,Express JS,MongoDB,firebase authentication</p>
                                <Button href='https://github.com/nhnajmul17/doctors-portal-client' style={{ marginRight: '3px' }} className='btn btn-info '>  <BiLinkExternal /> &nbsp;Client Side</Button>
                                <Button href='https://github.com/nhnajmul17/doctors-portal-server' style={{ marginRight: '3px' }} className='btn btn-info '>  <BiLinkExternal /> &nbsp;Server Side</Button>

                                <Button href='https://doctors-portal-001.web.app/' className='btn btn-info'>  <BiLinkExternal /> &nbsp;Live Site</Button>

                            </div>

                        </div>

                    </div>


                </div>


            </Container>
        </Container>
    );
};

export default Doctors;